'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Separator } from '@achra/ui/separator';
import type { GRANULARITY_OPTIONS } from '@/modules/finances/types';
import { BasicSelect } from '@/modules/shared/components/basic-select/basic-select';
import { DrawerSelect, FilterDrawer } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { MultipleSelector, type Option } from '@/modules/shared/components/form/multiselect';
interface ReservesWaterfallChartFiltersProps {
  granularityValue?: GRANULARITY_OPTIONS;
  granularityOptions: GRANULARITY_OPTIONS[];
  onGranularityChange: (selectedValue: string) => void;
  categoryOptions: Option[];
  selectedCategoryOptions: Option[];
  setActiveElements: (values: string[] | null) => void;
  canReset: boolean;
  onReset: () => void;
}
function ReservesWaterfallChartFilters(t0) {
  const $ = _c(46);
  const {
    granularityValue,
    granularityOptions,
    onGranularityChange,
    categoryOptions,
    selectedCategoryOptions,
    setActiveElements,
    canReset,
    onReset
  } = t0;
  let t1;
  if ($[0] !== categoryOptions.length || $[1] !== setActiveElements) {
    t1 = values => {
      const selectedValues = values.map(_temp);
      setActiveElements(selectedValues.length === categoryOptions.length ? null : selectedValues);
    };
    $[0] = categoryOptions.length;
    $[1] = setActiveElements;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleCategoriesChange = t1;
  let t2;
  if ($[3] !== selectedCategoryOptions) {
    t2 = selectedCategoryOptions.map(_temp2);
    $[3] = selectedCategoryOptions;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const selectedCategoryValues = t2;
  let t3;
  if ($[5] !== granularityOptions || $[6] !== granularityValue || $[7] !== onGranularityChange) {
    t3 = <BasicSelect label="Granularity" value={granularityValue} placeholder="Monthly" options={granularityOptions} onValueChange={onGranularityChange} className="min-w-38" />;
    $[5] = granularityOptions;
    $[6] = granularityValue;
    $[7] = onGranularityChange;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== categoryOptions || $[10] !== handleCategoriesChange || $[11] !== selectedCategoryOptions) {
    t4 = <MultipleSelector options={categoryOptions} value={selectedCategoryOptions} onChange={handleCategoriesChange} placeholder="All Categories" minVisibleItems={1} className="bg-background max-w-72 min-w-72" enableSelectAll={true} selectAllLabel="All Categories" />;
    $[9] = categoryOptions;
    $[10] = handleCategoriesChange;
    $[11] = selectedCategoryOptions;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = !canReset;
  let t6;
  if ($[13] !== onReset || $[14] !== t5) {
    t6 = <Button variant="ghost" className="text-foreground/50 px-4 hover:bg-transparent dark:hover:bg-transparent" onClick={onReset} disabled={t5}>Reset Filters</Button>;
    $[13] = onReset;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
    t7 = <div className="hidden items-center gap-3 md:flex lg:gap-4">{t3}{t4}{t6}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Separator orientation="vertical" className="h-7!" />;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = !canReset;
  let t10;
  if ($[21] !== onGranularityChange) {
    t10 = value => {
      onGranularityChange(value);
    };
    $[21] = onGranularityChange;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== granularityOptions) {
    t11 = granularityOptions.map(_temp3);
    $[23] = granularityOptions;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== granularityValue || $[26] !== t10 || $[27] !== t11) {
    t12 = <DrawerSelect value={granularityValue} onChange={t10} label="Granularity" options={t11} />;
    $[25] = granularityValue;
    $[26] = t10;
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== categoryOptions.length || $[30] !== setActiveElements) {
    t13 = values_0 => {
      setActiveElements(values_0.length === categoryOptions.length ? null : values_0);
    };
    $[29] = categoryOptions.length;
    $[30] = setActiveElements;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== categoryOptions) {
    t14 = categoryOptions.map(_temp4);
    $[32] = categoryOptions;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== selectedCategoryValues || $[35] !== t13 || $[36] !== t14) {
    t15 = <DrawerSelect value={selectedCategoryValues} onChange={t13} label="Categories" options={t14} multiselect={true} enableSelectAll={true} selectAllLabel="All Categories" />;
    $[34] = selectedCategoryValues;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== onReset || $[39] !== t12 || $[40] !== t15 || $[41] !== t9) {
    t16 = <div className="flex items-center gap-4 md:hidden">{t8}<FilterDrawer onReset={onReset} isResetDisabled={t9}>{t12}{t15}</FilterDrawer></div>;
    $[38] = onReset;
    $[39] = t12;
    $[40] = t15;
    $[41] = t9;
    $[42] = t16;
  } else {
    t16 = $[42];
  }
  let t17;
  if ($[43] !== t16 || $[44] !== t7) {
    t17 = <>{t7}{t16}</>;
    $[43] = t16;
    $[44] = t7;
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  return t17;
}
function _temp4(option_0) {
  return {
    label: option_0.label,
    value: option_0.value
  };
}
function _temp3(option) {
  return {
    label: option,
    value: option
  };
}
function _temp2(item_0) {
  return item_0.value;
}
function _temp(item) {
  return item.value;
}
export { ReservesWaterfallChartFilters };